import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-import",
  "use": "icon-import-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-import\"><path d=\"M5.418 10.081a.34.34 0 0 0 .357.043.323.323 0 0 0 .191-.296V7.607c2.138.008 3.615.157 5.405 3.228a.337.337 0 0 0 .378.154.326.326 0 0 0 .25-.314v-.258c.013-2.17.038-6.645-6.033-6.858V1.327a.326.326 0 0 0-.191-.296.344.344 0 0 0-.357.043L.123 5.322a.318.318 0 0 0-.003.5l5.298 4.26z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol